import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import RequirementEscalationsGridModel from "../../../../models/company/escalation/response/RequirementEscalationsGridModel";

interface EscalationHistoryProps {
    escalationsList: RequirementEscalationsGridModel[];
};

const EscalationHistoryComponent = (props: EscalationHistoryProps) => {

    const columnsCandidates = [
        { Key: "JobCode", text: "JobCode", sort: false, searchable: false },
        { Key: "CompanyName", text: "Company", sort: false, searchable: false },
        { Key: "EscalationDate", text: "Follow Up Dt", sort: false, searchable: false },
        { Key: "StatusName", text: "Status", sort: false, searchable: false },
        { Key: "Comments", text: "Comments", sort: false, searchable: false },
        { Key: "EscalatedBy", text: "Escalated By", sort: false, searchable: false },
        { Key: "CreatedOn", text: "Escalated Dt", sort: false, searchable: false }
    ];
    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnsCandidates.map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        <span>{column.text}</span>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.escalationsList.map((escalation: RequirementEscalationsGridModel, index) => (
                                <TableRow>
                                    <TableCell>{escalation.jobCode}</TableCell>
                                    <TableCell>{escalation.companyName}</TableCell>
                                    <TableCell>{escalation.escalationDateString}</TableCell>
                                    <TableCell>{escalation.statusName}</TableCell>
                                    <TableCell>{escalation.comments}</TableCell>
                                    <TableCell>{escalation.escalatedBy}</TableCell>
                                    <TableCell>{escalation.createdOn}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
};
export default EscalationHistoryComponent;